// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1to-Q","question":"styles_question__l_6Le","description":"styles_description__1kWLa"};